import React, { useEffect, useState } from "react";
import Navbar from "./Navbar";
import Fotter from "./Fotter";
import { Link, useNavigate } from "react-router-dom";
import SettingSidebar from "./SettingSidebar";
import { BASE_URL } from "../Pages/Config";
import axios from "axios";
import Cookies from "js-cookie";
import { FaTrash } from "react-icons/fa";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Swal from "sweetalert2";

import { formatDate } from "../components/dateUtils";

export default function SettingDraft() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showToast, setToastMessage] = useState("");

  const navigate = useNavigate();

  const fetchProducts = async () => {
    const userId = Cookies.get("user_id");
    if (!userId) return;
    try {
      const response = await axios.get(
        `${BASE_URL}/all_selling_user_item.php?type=draft&id=${userId}t=${Date.now()}`
      );

      if (response.data.success && Array.isArray(response.data.data)) {
        setProducts(response.data.data);
      } else {
        console.error("Unexpected API structure");
        setProducts([]);
      }
    } catch (error) {
      console.error("Failed to fetch products", error);
      setProducts([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
  }, []);

  const deleteproduct = async (productId: number) => {
    const confirm = await Swal.fire({
      title: "Are you sure?",
      text: "Remove this product?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, Save it!",
    });

    if (!confirm.isConfirmed) return;

    console.log(productId);
    try {
      const response = await axios.get(
        `${BASE_URL}/delete_item.php?id=${productId}`
      );
      console.log(response);

      if (response.data.success) {
        toast.success("Product deleted successfully.");
        fetchProducts();
      } else {
        toast.warning("Failed to delete product.");
      }
    } catch (error) {
      console.error("Delete error:", error);

      toast.error(
        "An error occurred while deleting the product. Try again Later"
      );
    }
  };

  return (
    <>
      <Navbar />

      <div className="page-info">
        <div className="container">
          <div className="row">
            <div className="col-12">
              <div className="info">
                <Link to="/">
                  <p>HOME </p>
                </Link>
                <span> /</span>
                <Link to="/">
                  <p>FASTTRADE</p>
                </Link>
                <span>/</span>

                <p>DRAFT</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="page-settings">
        <div className="container">
          <div className="row">
            <SettingSidebar />
            <div className="col-xl-9 col-lg-9 col-md-12 col-sm-12 col-12 ">
              <div className="col-12">
                <h2>
                  {loading ? (
                    <b>Loading...</b>
                  ) : (
                    <b>
                      Draft {products.length}{" "}
                      {products.length < 1 ? "Item" : "Items"}
                    </b>
                  )}
                </h2>
              </div>
              <div
                className="setting-info"
                style={{ background: "transparent" }}
              >
                <div className="row g-4">
                  {loading ? (
                    <div
                      key="loading"
                      className="loading-overlay"
                      style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "550px",
                      }}
                    >
                      <div className="dot-spinner">
                        {[...Array(8)].map((_, i) => (
                          <div key={i} className="dot-spinner__dot"></div>
                        ))}
                      </div>
                    </div>
                  ) : products.length === 0 ? (
                    <>
                      <img
                        src={`${BASE_URL}/uploads/logo/data_not_found.png`}
                        alt="No Data Found"
                        style={{
                          width: "100%",
                          height: "450px",
                          objectFit: "contain",
                          mixBlendMode: " darken",
                        }}
                      />
                    </>
                  ) : (
                    products.map((product) => (
                      <div
                        key={product.id}
                        className="col-xl-4 col-lg-4 col-md-6 wow animate fadeInDown"
                        data-wow-delay="200ms"
                        data-wow-duration="1500ms"
                      >
                        <div className="auction-card">
                          <div className="auction-card-img-wrap">
                            <div className="card-img">
                              <img
                                src={
                                  product.photo
                                    ? `${BASE_URL}/${product.photo
                                        .split(",")[0]
                                        .trim()}`
                                    : `${BASE_URL}/uploads/logo/icon.png`
                                }
                                alt={product.title}
                              />
                            </div>
                            <ul
                              className="view-and-favorite-area"
                              style={{ opacity: "15" }}
                            >
                              <li>
                                <span
                                  onClick={() => deleteproduct(product.id)}
                                  style={{
                                    cursor: "pointer",
                                    background: "white",
                                    padding: "10px 12px",
                                    borderRadius: "50%",
                                  }}
                                >
                                  <FaTrash
                                    style={{
                                      color: "#ebc32f",
                                      cursor: "pointer",
                                    }}
                                  />
                                </span>
                              </li>
                              {/* <li
                                style={{
                                  marginTop: "25px",
                                  marginLeft: "5px",
                                }}
                              >
                                <Link
                                  to={`/list-an-item-edit/${product.id}`}
                                  style={{
                                    background: "white",
                                    padding: "10px 12px",
                                    borderRadius: "50%",
                                    color: "green",
                                  }}
                                >
                                  <span
                                    style={{
                                      cursor: "pointer",
                                      background: "white",
                                      padding: "10px 12px",
                                      borderRadius: "50%",
                                      color: "green",
                                    }}
                                  >
                                    <FaEdit
                                      style={{
                                        color: "blue",
                                        cursor: "pointer",
                                      }}
                                    />
                                  </span>
                                </Link>
                              </li> */}
                            </ul>
                            {/* <CountdownTimer
                              closingTime={product.closing_time}
                            /> */}
                          </div>
                          <div className="auction-card-content">
                            <p style={{ fontSize: "12px" }}>
                              {formatDate(product.created_at)}
                            </p>
                            <h6>
                              <Link to="">{product.title}</Link>
                            </h6>

                            {/* <div className="details_buyer">
                              <h6>Price</h6>
                              <p
                                style={{ color: "#ebc32f", fontWeight: "800" }}
                              >
                                {product.current_price} SAR
                              </p>
                            </div> */}
                            {/* <p>
                              Description : lorem ipsum lorem ipsum lorem ipsum
                              lorem ipsum lorem ipsum
                            </p> */}

                            <div
                              className="price-and-code-area"
                              style={{ marginTop: "10px" }}
                            >
                              <div className="price">
                                <span>Current Bid at:</span>
                                <strong>{product.current_price}SAR</strong>
                              </div>
                              {/* <div className="code">
                                <span> # {product.id}</span>
                              </div> */}
                            </div>

                            <div className="rate_btn">
                              <Link to={`/list-an-item-edit/${product.id}`}>
                                <button>Edit</button>
                              </Link>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {showToast && (
        <div
          style={{
            position: "fixed",
            bottom: "20px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "10px 20px",
            borderRadius: "5px",
            zIndex: 9999,
          }}
        >
          {showToast}
        </div>
      )}

      <Fotter />
    </>
  );
}
